import { PropsWithPreview, SlideComponentImage } from '@/types/slide';
import { Box } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';

interface Props {
    model: SlideComponentImage;
}

export const ImageContent: React.FC<PropsWithPreview<Props>> = ({ model }) => {
    const isPlaceholder = !model.content.imageURL && !model.content.image;

    return (
        <Box
            id='image-component'
            sx={{
                m: 'inherit',
                p: 'inherit',
                width: '100%',
                height: '100%',
                aspectRatio: 'auto',
                transform: `scaleX(${model.content.flip ?? 1})`,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
        >
            {isPlaceholder ? (
                <Box
                    sx={{
                        backgroundColor: (theme) => (theme.vars || theme).palette.grey[200],
                        width: '100%',
                        height: '100%',
                        aspectRatio: 'auto',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <ImageIcon sx={{ color: (theme) => (theme.vars || theme).palette.grey[400], width: '60%', height: '60%' }} />
                </Box>
            ) : (
                <Box
                    component='img'
                    alt='image'
                    src={model.content.imageURL ? model.content.imageURL : `/asset/characters/${model.content.image}/image.png`}
                    sx={{
                        width: '100%',
                        height: '100%',
                        aspectRatio: 'auto',
                    }}
                />
            )}
        </Box>
    );
};
